import {combineReducers} from 'redux';

import objects from './objects';
export default combineReducers({
  objects,
});
